import "./_seperator-with-action.scss";

import classNames from "classnames";

import {ButtonProps} from "../button/Button.types";
import Line from "../line/Line";
import IconButton from "../button/icon/IconButton";

interface SeperatorWithActionProps {
  icon: React.ReactNode;
  buttonProps?: Omit<ButtonProps, "children">;
  customClassName?: string;
}

function SeperatorWithAction({
  icon,
  buttonProps,
  customClassName
}: SeperatorWithActionProps) {
  return (
    <div className={classNames("seperator-with-action", "is-centered", customClassName)}>
      <Line />

      <IconButton customClassName={"seperator-with-action__button"} {...buttonProps}>
        {icon}
      </IconButton>
    </div>
  );
}

export default SeperatorWithAction;
